import { render, staticRenderFns } from "./SubscriberCard.vue?vue&type=template&id=2356d19b&scoped=true&"
import script from "./SubscriberCard.vue?vue&type=script&lang=js&"
export * from "./SubscriberCard.vue?vue&type=script&lang=js&"
import style0 from "./SubscriberCard.vue?vue&type=style&index=0&id=2356d19b&lang=scss&scoped=true&"
import style1 from "./SubscriberCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2356d19b",
  null
  
)

export default component.exports